import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Nebesa so polna!",
  "description": "",
  "published": "2007-02-06T00:00:00.000Z",
  "redirect_from": ["/blog/nebesa-so-polna/swizec/290"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ob vsakodnevnem opazovanju spleta sem slucajno zapazil, da so nebesa, normalnim ljudem poznana kot Nizka Zemljina Orbita, sedaj `}<a parentName="p" {...{
        "href": "http://www.nytimes.com/2007/02/06/science/space/06orbi.html?ex=1328418000&en=16b9c6ba615c2e62&ei=5088&partner=rssnyt&emc=rss"
      }}>{`uradno polna in v velikih tezavah`}</a>{` ce se okoli tega nic ne postori.`}</p>
    <p>{`V drugih novicah, samo zato, ker navijam za Linux, je tu `}<a parentName="p" {...{
        "href": "http://blogs.zdnet.com/threatchaos/?p=311"
      }}>{`lepa razlaga`}</a>{` zakaj je Linux boljsi.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      